import { useOrganizationList } from "@clerk/react";

import { redirectAfterAuth } from "@/lib/auth-helpers";
import { followDecorated } from "@/lib/follow-auth";
import { OrganizationCreateForm } from "@/pages/sign-up/organization";

const ChooseOrganizationTaskPage = () => {
  const { isLoaded, setActive, userMemberships } = useOrganizationList({
    userMemberships: { infinite: true },
  });
  const memberships = userMemberships.data ?? [];

  if (!isLoaded) {
    return <p className="text-n-600">Loading</p>;
  }

  if (memberships.length === 0) {
    return <OrganizationCreateForm />;
  }

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-2">
        <h1 className="font-semibold text-[32px] leading-[1.1] tracking-[-0.02em]">
          Choose organization
        </h1>
        <p className="text-base text-n-600 leading-[1.55]">
          Select the workspace to continue.
        </p>
      </div>
      <ul className="m-0 flex list-none flex-col gap-2 p-0">
        {memberships.map((membership) => (
          <li key={membership.id}>
            <button
              className="auth-focus h-[52px] w-full rounded-[10px] border border-n-200 bg-white px-4 text-left font-medium text-base"
              onClick={() => {
                setActive({
                  navigate: ({ decorateUrl }) =>
                    followDecorated(decorateUrl, redirectAfterAuth()),
                  organization: membership.organization.id,
                }).catch(() => undefined);
              }}
              type="button"
            >
              {membership.organization.name}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ChooseOrganizationTaskPage;
